import { reactive } from "vue";
import LayoutHeaderApp from "../layout/header/HeaderApp.vue";
import { createLayoutApp } from "../layout/createLayoutApp";
import { getLayoutModel, pickLayoutProps } from "../layout/layoutModel";
import { ensureTourOperatorOfficeContactsBindings } from "../layout/tourOperatorOfficeContactsLoader";
import "../layout/gdprConsent";

const mountEl = document.getElementById("site-header");
if (mountEl && mountEl.getAttribute("data-vue3") === "true") {
  const layoutModel = getLayoutModel() ?? {};
  const sharedModel = window.layoutModel ?? reactive(layoutModel);
  const { updateTourOperatorOfficeContacts, ensureTourOperatorOfficeContacts } =
    ensureTourOperatorOfficeContactsBindings(sharedModel);
  window.layoutModel = sharedModel;
  const props = pickLayoutProps(sharedModel, [
    "mainMenu",
    "mainMenuMyAccount",
    "currencyRateInfo",
    "isAuthorized",
    "agencyUserName",
    "agencyLocation",
    "loginUrl",
    "userMenu",
    "tourOperatorOfficeContacts",
    "updateTourOperatorOfficeContactsFn",
    "ensureTourOperatorOfficeContactsFn",
    "supportedLanguages",
    "convertedAllToCurrency",
    "logoUrl",
    "goToB2CSuggestion",
    "b2CUrl",
    "feedbackUrl",
    "showManageBookingLink",
    "wideBannerHtml"
  ]);
  props.updateTourOperatorOfficeContactsFn = updateTourOperatorOfficeContacts;
  props.ensureTourOperatorOfficeContactsFn = ensureTourOperatorOfficeContacts;
  const app = createLayoutApp(LayoutHeaderApp, props);
  const root = document.createElement("div");
  mountEl.replaceWith(root);
  app.mount(root);
}
